<template>
    <div class="image-crop">
        <div class="origin-image">
            <img ref="img" :src="src" />
        </div>
        <div class="image-preview">
            <div class="cube" ref="previewCube"></div>
            <div class="round" ref="previewRound"></div>
        </div>
    </div>
</template>

<script>
import Croppjs from "cropperjs";
import "cropperjs/dist/cropper.css";

export default {
    props: {
        src: {
            type: String,
        },
    },
    data() {
        this.crop = null;
        return {};
    },
    watch: {
        src() {
            this.crop.replace(this.src);
        },
    },
    mounted() {
        this.crop = new Croppjs(this.$refs.img, {
            aspectRatio: 1,
            preview: [this.$refs.previewCube, this.$refs.previewRound],
        });
    },
    beforeDestroy() {
        this.crop.destroy();
    },
    methods: {
        beforeClose() {
            return this.getImage();
        },
        async getImage() {
            return new Promise((r, j) => {
                this.crop
                    .getCroppedCanvas({
                        width: 400,
                        height: 400,
                        minWidth: 256,
                        minHeight: 256,
                        maxWidth: 1000,
                        maxHeight: 1000,
                        fillColor: "#fff",
                        imageSmoothingEnabled: false,
                        imageSmoothingQuality: "high",
                    })
                    .toBlob((blob) => {
                        r(blob);
                    }, "image/png");
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.image-crop {
    width: 540px;
    height: 300px;
    display: flex;
    .origin-image {
        flex: 340px 0 0;
        position: relative;
        overflow: hidden;
    }
    .image-preview {
        flex: auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        column-gap: 20px;
        row-gap: 20px;
        .cube {
            width: 100px;
            flex: 100px 0 0;
            overflow: hidden;
            pointer-events: none;
        }
        .round {
            width: 100px;
            flex: 100px 0 0;
            border-radius: 50%;
            overflow: hidden;
            pointer-events: none;
        }
    }
}
</style>